import './video.scss';
import './video.html.twig';

export default () => {
  const videos = document.querySelectorAll('.video-block__inner');

  if (!videos) {
    return;
  }

  Array.from(videos).forEach((el) => {
    const transcriptBtn = el.querySelector('.video-block__transcript-btn');
    const transcript = el.querySelector('.video-block__transcript');

    // set tabindex of links to '-1' so that they can't be selected when the transcript panel is closed
    const links = transcript.querySelectorAll('a');
    Array.prototype.forEach.call(links, function (link) {
      link.setAttribute('tabindex', '-1');
    });

    if (transcriptBtn) {
      const btnTextEl = transcriptBtn.querySelector('span');

      const showTranscript = () => {
        transcriptBtn.setAttribute('aria-expanded', 'true');
        transcript.setAttribute('aria-hidden', 'false');
        transcriptBtn.classList.add('video-block__transcript-btn-open');
        btnTextEl.innerText = 'Hide transcript';
        Array.prototype.forEach.call(links, function (link) {
          link.setAttribute('tabindex', '0');
        });
      };

      const hideTranscript = () => {
        transcriptBtn.setAttribute('aria-expanded', 'false');
        transcript.setAttribute('aria-hidden', 'true');
        transcriptBtn.classList.remove('video-block__transcript-btn-open');
        btnTextEl.innerText = 'Show transcript';
        Array.prototype.forEach.call(links, function (link) {
          link.setAttribute('tabindex', '-1');
        });
      };

      const toggleTranscript = () => {
        if (transcriptBtn.getAttribute('aria-expanded') === 'true') {
          hideTranscript();
        } else {
          showTranscript();
        }
      };

      transcriptBtn.addEventListener('click', toggleTranscript);
    }
  });
};
